import * as f from "standard/f";
import globalStorage from "standard/globalStorage";

Object.entries(
  JSON.parse(
    f.or(
      document.querySelector("script[type='application/json']")?.textContent,
      "{}",
    ),
  ),
).forEach(([key, value]) => globalStorage.setItem(key, value));
